import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Button, FormGroup, Label, Input } from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import "../stylesheets/style.scss";
import { Project_APIs } from "./Project_APIs";
import { Project_Variables } from "./Project_Variables";
import { UserConsumer } from "../../UserContext";
import { goBackFunction } from "../../utils";
import { Redirect } from "react-router-dom";
import FormStatus from "../../components/FormStatus";
import CustomReactSelect from "../../components/CustomReactSelect";
import { AlertPopups } from "../../components/AlertPopups";
import { Routes } from "../../configurations/config";

const validation = Yup.object().shape({
	Notes: Yup.string().max(50, "Max 500 characters allowed"),
	devOpsName: Yup.string()
		.max(255, "Max 255 characters allowed")
		.required("Name can't be empty"),
	areaPath: Yup.string()
		.max(255, "Max 255 characters allowed")
		.required("Area path can't be empty"),
});
let token = null;
class UpdateProject extends Component {
	constructor(props) {
		super(props);

		this.state = {
			projectName: "",
			projectType: "",
			supervisor: "",
			allocateTo: [],
			allocateTo1: [],
			Notes: "",
			date: new Date().toDateString(),
			supervisorsList: [],
			allocateToList: [],
			allProjectsDetail: [],
			projectDetails: [],
			projectTypeList: [],
			nameErr: false,
			totalRecords: 0,
			devOpsName: "",
			areaPath: "",
		};
	}

	supervisorsListValues() {
		return this.state.supervisorsList.map((data) => ({
			label: data.name,
			value: data.employeeId,
		}));
	}
	allocatedToListValues() {
		return this.state.allocateToList.map((data) => ({
			label: data.name,
			value: data.employeeId,
		}));
	}
	projectTypeValues() {
		return this.state.projectTypeList.map((data) => ({
			label: data.projectType,
			value: data.id,
		}));
	}
	componentDidMount() {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(
				`${Project_APIs.GetProjectDetails_API}/${this.props.match.params.projectId}/GetProjectDetails`,
				{ headers: headers }
			)
			.then((res) => {
				this.setState({
					projectDetails: res.data.projectDetails,
					projectName: res.data.projectDetails.projectName,
					devOpsName: res.data.projectDetails.devopsProjectName,
					areaPath: res.data.projectDetails.devopsAreaPath,
				});
				res.data.allocateTo.length !== 0 &&
					this.setState({
						allocateTo: res.data.allocateTo,
					});
				let temp = this.state.allocateTo.map((data) => ({
					label: data.name,
					value: data.employeeId,
				}));
				this.setState({
					allocateTo: temp,
				});
				this.state.projectDetails.projectType !== null
					? this.setState({
							projectType: {
								value: this.state.projectDetails.projectTypeId,
								label: this.state.projectDetails.projectType,
							},
					  })
					: this.setState({ projectType: "" });
				this.state.projectDetails.supervisorId !== null
					? this.setState({
							supervisor: {
								value: this.state.projectDetails.supervisorId,
								label: this.state.projectDetails.supervisorName,
							},
					  })
					: this.setState({ supervisor: "" });

				this.state.projectDetails.notes !== null &&
				this.state.projectDetails.notes !== ""
					? this.setState({
							Notes: this.state.projectDetails.notes,
					  })
					: this.setState({ Notes: "" });
			});

		axios
			.get(`${Project_APIs.GetProjectType_API}`, { headers: headers })
			.then((res) => {
				this.setState({ projectTypeList: res.data });
			});
		axios
			.get(`${Project_APIs.GetSupervisors_API}`, { headers: headers })
			.then((res) => {
				this.setState({ supervisorsList: res.data });
			});
		axios
			.get(`${Project_APIs.GetAllEmployeesWithCode_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({ allocateToList: res.data });
			});
	}
	handleChange = (temp, displayCode, event) => {
		if (displayCode === 1 || displayCode === 5) {
			this.setState({
				[temp.target.name]: temp.target.value,
			});
		} else if (
			displayCode === 2 ||
			displayCode === 3 ||
			displayCode === 4
		) {
			this.setState({
				[event.name]: temp,
			});
		}
	};
	handleBlur = (event) => {
		this.setState({ nameErr: false });
		if (event.target.value !== null || event.target.value !== "") {
			for (let i = 0; i < this.state.totalRecords - 1; i++) {
				if (
					this.state.allProjectsDetail[
						i
					].projectDetails.projectName.toLowerCase() !==
					event.target.value.toLowerCase()
				) {
					continue;
				} else {
					if (
						this.state.allProjectsDetail[i].projectDetails
							.projectId !==
						parseInt(this.props.match.params.projectId)
					) {
						this.setState({ nameErr: true });
						return;
					}
				}
			}
		}
	};

	handleSubmit = (values, e) => {
		e.preventDefault();
		if (values.devOpsName === "" || values.devOpsName === null) {
			AlertPopups.WarningAlert.fire({
				text: `DevOps Name is required`,
			});
		} else if (values.areaPath === "" || values.areaPath === null) {
			AlertPopups.WarningAlert.fire({
				text: `DevOps Area path is required`,
			});
		} else {
			if (this.state.nameErr === false) {
				let allocateToIds = [];

				if (this.state.allocateTo) {
					this.state.allocateTo.forEach((element) => {
						allocateToIds.push(element.value);
					});
				}

				AlertPopups.confirmBox
					.fire({
						text: `${Project_Variables.saveChangesConfirm}`,
					})
					.then((result) => {
						let self = this;
						if (result.value) {
							const headers = {
								Authorization: `Bearer ${token}`,
							};
							let data = {
								ProjectId: parseInt(
									this.props.match.params.projectId
								),
								ProjectName: values.projectName,
								devopsProjectName: values.devOpsName,
								devopsAreaPath: values.areaPath,
								Employees: allocateToIds,
								ProjectCategory:
									values.projectType !== null
										? values.projectType.value
										: null,
								SupervisorId:
									values.supervisor !== null
										? values.supervisor.value
										: null,
								Notes: values.Notes,
							};
							axios
								.put(`${Project_APIs.EditProject_API}`, data, {
									headers: headers,
								})
								.then(function (response) {
									if (response.status === 200) {
										AlertPopups.successAlert.fire({
											text: `${Project_Variables.saveChangesMsg}`,
										});
										goBackFunction(
											Routes.ProjectListing,
											self.props.history
										);
									}
								})
								.catch(() => {
									AlertPopups.WarningAlert.fire({
										text: `Try again please`,
									});
								});
						}
					});
			}
		}
	};
	goBack = () => {
		goBackFunction(Routes.ProjectListing, this.props.history);
	};
	render() {
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;

					return userDetails.designation.toString() === "4" ||
						userDetails.id.toString() === "180" ||
						userDetails.id.toString() === "786" ||
						userDetails.id.toString() === "269" ? (
						<div className="container-fluid pl-4 pr-4">
							<FormStatus
								title={
									this.props.history.location
										? this.props.history.location.state
												.projectName
										: "Update Project"
								}
								className="create-request d-flex align-items-center"
								onClick={this.goBack}
								navigateBack={true}
							/>
							<Formik
								initialValues={this.state}
								validationSchema={validation}
								validateOnChange={true}
								enableReinitialize={true}
							>
								{({ errors, handleBlur, values }) => (
									<form
										onSubmit={(e) =>
											this.handleSubmit(values, e)
										}
										className="itemReqForm"
									>
										<FormGroup
											row
											id="row0"
											className="bottom-spacing topBorders"
										>
											<Label sm={12}>Edit Project</Label>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle1"
										>
											<Label for="projectName" sm={2}>
												Project Name
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={10}>
												<span className="dataSpan">
													{this.state.projectName}
												</span>
												{this.state.nameErr && (
													<div className="input-feedback">
														Project name already
														used, please use some
														other name.
													</div>
												)}
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle2"
										>
											<Label for="devOpsName" sm={2}>
												DevOps Name
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={4}>
												<Input
													type="text"
													value={
														this.state.devOpsName
													}
													placeholder="Type Project's devOps Name"
													name="devOpsName"
													id="devOpsName"
													bsSize="sm"
													autoComplete="off"
													onChange={(value, event) =>
														this.handleChange(
															value,
															1,
															event
														)
													}
													className={
														errors.devOpsName
															? "invalid"
															: ""
													}
													maxLength="255"
												/>
											</Col>
											<Label for="areaPath" sm={2}>
												DevOps Area path
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={4}>
												<Input
													type="text"
													value={this.state.areaPath}
													placeholder="Type Project's devOps area path"
													name="areaPath"
													id="areaPath"
													bsSize="sm"
													autoComplete="off"
													onChange={(value, event) =>
														this.handleChange(
															value,
															1,
															event
														)
													}
													className={
														errors.areaPath
															? "invalid"
															: ""
													}
													maxLength="255"
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle1"
										>
											<Label for="projectType" sm={2}>
												Project Type
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={10}>
												<CustomReactSelect
													placeholder="Presales, Inhouse, Fixed term"
													options={this.projectTypeValues()}
													name="projectType"
													id="projectType"
													styles={
														Project_Variables.react_select_style
													}
													bsSize="sm"
													onChange={(value, event) =>
														this.handleChange(
															value,
															2,
															event
														)
													}
													isClearable
													value={
														this.state.projectType
													}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle2"
										>
											<Label for="supervisorsList" sm={2}>
												Supervisor
											</Label>
											<Col sm={10}>
												<CustomReactSelect
													options={this.supervisorsListValues()}
													name="supervisor"
													styles={
														Project_Variables.react_select_style
													}
													id="supervisor"
													onChange={(value, event) =>
														this.handleChange(
															value,
															3,
															event
														)
													}
													value={
														this.state.supervisor
													}
													bsSize="sm"
													placeholder=""
													onBlur={handleBlur}
													isClearable
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle1"
										>
											<Label for="allocateToList" sm={2}>
												Team
											</Label>
											<Col sm={10}>
												<CustomReactSelect
													options={this.allocatedToListValues()}
													multipule={true}
													name="allocateTo"
													id="allocateTo"
													styles={
														Project_Variables.react_multiselect_style
													}
													onChange={(value, event) =>
														this.handleChange(
															value,
															4,
															event
														)
													}
													value={
														this.state.allocateTo
													}
													placeholder=""
													bsSize="sm"
													onBlur={handleBlur}
													isClearable
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="rowStyle2 bottomBorders"
										>
											<Label for="Notes" sm={2}>
												Add Notes
											</Label>
											<Col sm={10}>
												<Input
													type="textarea"
													name="Notes"
													id="Notes"
													onChange={(value, event) =>
														this.handleChange(
															value,
															5,
															event
														)
													}
													onBlur={handleBlur}
													value={this.state.Notes}
													maxLength="500"
													className="h-auto"
												/>
											</Col>
										</FormGroup>
										<div className="btns mt-4">
											<Button
												className="submit-btn"
												type="Submit"
												hidden={
													this.state.disableChange
												}
											>
												Update
											</Button>
										</div>
									</form>
								)}
							</Formik>
						</div>
					) : (
						<Redirect to="/MyDashboard" />
					);
				}}
			</UserConsumer>
		);
	}
}
export default UpdateProject;
